<style scoped lang="less">
</style>

<template>
    <div class="yb-container">
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import { HttpClient } from "../util/http";
import DialogBigImage from "../components/dialog/dialogBigImage.vue";
import { removeModel } from "../util/restful";
import { actionConfirm, msgSuccess, msgError } from "../util/toast";
import { loginState } from "../util/login.js";

import _ from "lodash";

export default {
    components: {
        DialogBigImage,
        PagedTable,
    },
    mixins: [],
    data() {
        return {};
    },
    created() {},
    computed: {},
    mounted() {},
    methods: {},
};
</script>
